import React from "react";
import { CalendarX2, Loader2, BadgeCheck, Wallet } from "lucide-react";
import { cancellationLines } from "@/lib/propertyRules";

const isTrue = (f) => f && typeof f === "object" && f.value === true;

// Shown immediately before payment: the real cancellation terms for the chosen
// dates (fees/quote), plus ID / deposit from the property rules, plus the tick
// the guest must give before paying.
export const RulesAgreement = ({ quoteTerms, rules, loading = false, agreed, setAgreed, idPrefix = "" }) => {
  const lines = cancellationLines(quoteTerms);
  const idNeeded = isTrue(rules?.id_required_at_checkin);
  const deposit = isTrue(rules?.security_deposit_required);

  return (
    <div className="space-y-3" data-testid={`${idPrefix}rules-agreement`}>
      <div className="flex items-start gap-3 rounded-2xl border border-black/8 bg-white px-4 py-3">
        <CalendarX2 className="w-4 h-4 text-brand mt-0.5 shrink-0" aria-hidden="true" />
        <div className="text-sm text-ink-soft space-y-0.5" data-testid={`${idPrefix}cancellation-terms`}>
          <p className="font-semibold text-ink">Cancellation</p>
          {loading && lines.length === 0 ? (
            <p className="inline-flex items-center gap-1.5"><Loader2 className="w-3.5 h-3.5 animate-spin" /> Checking your dates…</p>
          ) : lines.length > 0 ? (
            lines.map((l) => <p key={l}>{l}</p>)
          ) : (
            <p>Cancellation terms will be confirmed by the property.</p>
          )}
        </div>
      </div>

      {(idNeeded || deposit) && (
        <div className="rounded-2xl border border-black/8 bg-white px-4 py-3 space-y-2" data-testid={`${idPrefix}arrival-requirements`}>
          {idNeeded && (
            <p className="flex items-start gap-3 text-sm text-ink-soft">
              <BadgeCheck className="w-4 h-4 text-brand mt-0.5 shrink-0" aria-hidden="true" />
              Photo ID required at check-in{rules.id_required_at_checkin.note ? ` — ${rules.id_required_at_checkin.note}` : ""}
            </p>
          )}
          {deposit && (
            <p className="flex items-start gap-3 text-sm text-ink-soft">
              <Wallet className="w-4 h-4 text-brand mt-0.5 shrink-0" aria-hidden="true" />
              Security deposit required{rules.security_deposit_required.note ? ` — ${rules.security_deposit_required.note}` : ""}
            </p>
          )}
        </div>
      )}

      <label className="flex items-start gap-3 cursor-pointer select-none px-1">
        <input
          type="checkbox"
          checked={agreed}
          onChange={(e) => setAgreed(e.target.checked)}
          data-testid={`${idPrefix}agree-rules`}
          className="mt-0.5 w-4 h-4 accent-[#FF1A1A] shrink-0"
        />
        <span className="text-sm text-ink">I agree to the property rules and cancellation terms</span>
      </label>
    </div>
  );
};

export default RulesAgreement;
